'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { XIcon } from 'lucide-react';
import { Dialog as SheetPrimitive } from 'radix-ui';
import { cn } from '../../../lib/utils.js';
import { Button } from '../button.jsx';
function Sheet(_a) {
    var props = __rest(_a, []);
    return <SheetPrimitive.Root data-slot="sheet" {...props}/>;
}
function SheetTrigger(_a) {
    var props = __rest(_a, []);
    return <SheetPrimitive.Trigger data-slot="sheet-trigger" {...props}/>;
}
function SheetClose(_a) {
    var props = __rest(_a, []);
    return <SheetPrimitive.Close data-slot="sheet-close" {...props}/>;
}
function SheetPortal(_a) {
    var props = __rest(_a, []);
    return <SheetPrimitive.Portal data-slot="sheet-portal" {...props}/>;
}
function SheetOverlay(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<SheetPrimitive.Overlay data-slot="sheet-overlay" className={cn('data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0 fixed inset-0 z-50 bg-black/50', className)} {...props}/>);
}
function SheetContent(_a) {
    var className = _a.className, children = _a.children, _b = _a.side, side = _b === void 0 ? 'right' : _b, _c = _a.showCloseButton, showCloseButton = _c === void 0 ? true : _c, props = __rest(_a, ["className", "children", "side", "showCloseButton"]);
    return (<SheetPortal>
      <SheetOverlay />
      <SheetPrimitive.Content data-slot="sheet-content" data-side={side} className={cn('bg-popover text-popover-foreground data-open:animate-in data-open:fade-in-0 data-[side=bottom]:data-open:slide-in-from-bottom-10 data-[side=left]:data-open:slide-in-from-left-10 data-[side=right]:data-open:slide-in-from-right-10 data-[side=top]:data-open:slide-in-from-top-10 data-closed:animate-out data-closed:fade-out-0 data-[side=bottom]:data-closed:slide-out-to-bottom-10 data-[side=left]:data-closed:slide-out-to-left-10 data-[side=right]:data-closed:slide-out-to-right-10 data-[side=top]:data-closed:slide-out-to-top-10 fixed z-50 flex flex-col gap-4 bg-clip-padding text-sm shadow-lg transition duration-200 ease-in-out data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm', className)} {...props}>
        {children}
        {showCloseButton && (<SheetPrimitive.Close data-slot="sheet-close" asChild>
            <Button variant="ghost" className="absolute top-3 right-3" size="icon-sm">
              <XIcon />
              <span className="sr-only">Close</span>
            </Button>
          </SheetPrimitive.Close>)}
      </SheetPrimitive.Content>
    </SheetPortal>);
}
function SheetHeader(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="sheet-header" className={cn('flex flex-col gap-0.5 p-4', className)} {...props}/>);
}
function SheetFooter(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="sheet-footer" className={cn('mt-auto flex flex-col gap-2 p-4', className)} {...props}/>);
}
function SheetTitle(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<SheetPrimitive.Title data-slot="sheet-title" className={cn('cn-font-heading text-foreground text-base font-medium', className)} {...props}/>);
}
function SheetDescription(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<SheetPrimitive.Description data-slot="sheet-description" className={cn('text-muted-foreground text-sm', className)} {...props}/>);
}
export { Sheet, SheetTrigger, SheetClose, SheetContent, SheetHeader, SheetFooter, SheetTitle, SheetDescription, };
